import React from 'react'

import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import { StorageIds } from '@sportworld/js-sdk/src/constants/storage'
import { AuthProvider } from '@sportworld/js-sdk/src/context/authContext'

import App from './App'
import { getPlatformBase64 } from './platform/platform'
import 'intl-pluralrules'

declare global {
  interface Window {
    appLoadTimestamp: number | null
    device: any
    timeouts: any[]
    __tcfapi: (
      command: string,
      version: number,
      callback: (tcData: any, success: boolean) => void,
    ) => void
    __ucCmp: any
    UC: any
  }
}

window.timeouts = []

Sentry.addTracingExtensions()

Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  release: import.meta.env.REACT_APP_VERSION,
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0,
})

Promise.resolve()
  .then(() => {
    const platform = getPlatformBase64()
    const lsPlatform = localStorage.getItem(StorageIds.platform)
    if (lsPlatform !== platform) {
      localStorage.setItem(StorageIds.platform, platform)
    }
  })
  .then(() => {
    const elementById = document.getElementById('root')
    if (!elementById) {
      return
    }
    const root = createRoot(elementById)
    root.render(
      <React.StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </React.StrictMode>,
    )
  })
